import React, { useEffect, useState } from "react";
import BrandsHeader from "./BrandsHeader";
import SearchAndFilter from "./SearchAndFilter";
import BrandGrid from "./BrandGrid";
import "./Styling.css";
import AllBrandsPageSkeleton from "./Skeletons/AllBrandsPageSkeleton";
import { brandWiseInsights } from "../../services/dataAnalyticsApi";

const AllBrandsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [brandsData, setBrandsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchData = async () => {
      try {
        const response = await brandWiseInsights();
        setBrandsData(response.data.data); 
        
      } catch (err) {
        setError("Failed to fetch brand data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="all-brands-wrapper">
      <div className="brand-search">
        <BrandsHeader />
        <SearchAndFilter
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
        />
      </div>
      {loading ? (
        <AllBrandsPageSkeleton />
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <BrandGrid searchTerm={searchTerm} brandsData={brandsData} />
      )}
    </div>
  );
};

export default AllBrandsPage;
